import { Component, OnInit } from '@angular/core';
import { FlaggedQuestionsListComponent } from '../flagged-questions-list/flagged-questions-list.component';
import { Question } from 'app/shared/models/question';

@Component({
  selector: 'dac-flagged-questions-list-simple',
  templateUrl: './flagged-questions-list-simple.component.html',
  styleUrls: ['./flagged-questions-list-simple.component.scss']
})
export class FlaggedQuestionsListSimpleComponent extends FlaggedQuestionsListComponent implements OnInit {

  private flaggedQuestions:Question[];
  
  constructor() { 
    super();
    this.flaggedQuestions = [];
  }


  ngOnInit() {
    this.flaggedQuestions = this.Assessments.map(a => a.getFlaggedQuestions()).reduce((prev, curr) => curr.concat(prev), []);
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  
  get FlaggedQuestions() {

    return this.flaggedQuestions;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/flagged-questions-list-simple/flagged-questions-list-simple.component.ts